import classNames from 'classnames'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router'
import { Button, Image } from 'semantic-ui-react'
import { DirectUpload, t } from 'shared'
import styles from './image_upload.module.css'
import { ImageUploadProps, PreviewComponent, UploadCb } from './types'
import { uploadButtonFactory } from './upload_button_factory'

export const ImageUpload = ({
  onUpload: onUpload_,
  imageUrl: imageUrl_,
  className,
  previewCmp: Preview = Image as PreviewComponent,
  previewClassName,
  cropBtnClassName,
  cropUrl,
  error,
  label,
}: ImageUploadProps) => {
  const [tempPhotoUrl, setTempPhotoUrl] = useState<string | undefined>(undefined)
  const imageUrl = useMemo(() => tempPhotoUrl ?? imageUrl_ ?? undefined, [tempPhotoUrl, imageUrl_])
  const Btn = useMemo(() => uploadButtonFactory(!!imageUrl, label), [imageUrl, label])
  const onUpload: UploadCb = useCallback(
    (photoId, photoUrl) => {
      setTempPhotoUrl(photoUrl)
      onUpload_(photoId)
    },
    [onUpload_]
  )
  // clear temp photo url after uploaded image change is complete
  useEffect(() => {
    if (!imageUrl_) return
    setTempPhotoUrl(undefined)
  }, [imageUrl_])

  return (
    <div className={classNames(styles.container, className)}>
      {imageUrl ? <Preview src={imageUrl} className={classNames(previewClassName, styles.preview)} /> : null}
      <div className={styles.buttons}>
        {cropUrl && imageUrl && (
          <Button
            icon="crop"
            content={t('misc.change_cropping')}
            as={Link}
            to={cropUrl}
            className={classNames(styles.cropButton, cropBtnClassName)}
            primary
            basic
          />
        )}
        <DirectUpload onUpload={onUpload} triggerComponent={Btn} className={styles.upload} error={error ?? undefined} />
      </div>
    </div>
  )
}
